module.exports = __webpack_public_path__ + "img/Chilean-Antarctic-Te.e2f48d4e.png";